import { call, put } from "redux-saga/effects";
import {
  REQUEST_ERROR,
  REQUESTING,
  REQUEST_SUCCESS
} from "../types/request.types";
import moment from "moment";
import axios from "axios";

const urlAPI = "/api";

export async function fetcher(method = "GET", route = "carte", body, header) {
  try {
    const result = await axios({
      method: method,
      headers: {
        "Content-Type": "application/json",
        authorization: header,
        refreshToken: header
      },
      url: `${urlAPI}/${route}`,
      data: body
    });
    return result;
  } catch (err) {
    return err;
  }
}

export function* requestHandler(method, route, body, header) {
  try {
    const requestObj = {
      method: method,
      time: moment().format("DD/MM/YYYY HH:mm")
    };
    yield put({ type: REQUESTING, request: requestObj });
    const result = yield call(fetcher, method, route, body, header);
    const successFullRequest = {
      ...requestObj
    };
    yield put({ type: REQUEST_SUCCESS, requestSuccess: successFullRequest });
    return result;
  } catch (err) {
    yield put({
      type: REQUEST_ERROR,
      error: err
    });

    return { result: false };
  }
}
